import React, { useState } from 'react';
import { testimonials } from '../mock';
import { Star, Quote, ChevronLeft, ChevronRight } from 'lucide-react';

const TestimonialsSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section className="testimonials-section" id="testimonials">
      <div className="section-container">
        <div className="section-header-center">
          <span className="section-label">Client Success Stories</span>
          <h2 className="section-title">
            What Our Clients
            <span className="title-highlight"> Say About Us</span>
          </h2>
          <p className="section-description">
            Don't just take our word for it. Hear from businesses we've helped protect 
            their brands through professional trademark registration services.
          </p>
        </div>

        {/* Featured Testimonial */}
        <div className="featured-testimonial">
          <div className="quote-icon">
            <Quote size={48} />
          </div>
          <div className="testimonial-content">
            <div className="testimonial-stars">
              {[...Array(testimonials[currentIndex].rating)].map((_, i) => (
                <Star key={i} size={20} fill="currentColor" />
              ))}
            </div>
            <p className="testimonial-text">{testimonials[currentIndex].text}</p>
            <div className="testimonial-author">
              <div className="author-info">
                <div className="author-name">{testimonials[currentIndex].name}</div>
                <div className="author-company">{testimonials[currentIndex].company}</div>
                <div className="author-industry">{testimonials[currentIndex].industry}</div>
              </div>
            </div>
          </div>
          
          <div className="testimonial-navigation">
            <button onClick={prevTestimonial} className="nav-button" aria-label="Previous testimonial">
              <ChevronLeft size={24} />
            </button>
            <div className="testimonial-dots">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentIndex(index)}
                  className={`testimonial-dot ${currentIndex === index ? 'active' : ''}`}
                  aria-label={`View testimonial ${index + 1}`}
                />
              ))}
            </div>
            <button onClick={nextTestimonial} className="nav-button" aria-label="Next testimonial">
              <ChevronRight size={24} />
            </button>
          </div>
        </div>

        {/* All Testimonials Grid */}
        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <div key={testimonial.id} className="testimonial-card">
              <div className="testimonial-card-stars">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} size={16} fill="currentColor" />
                ))}
              </div>
              <p className="testimonial-card-text">{testimonial.text}</p>
              <div className="testimonial-card-author">
                <div className="card-author-name">{testimonial.name}</div>
                <div className="card-author-company">{testimonial.company}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
